import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FireDataService } from '../fire-log/fire-data.service';
import { FormBuilder, Validators } from '@angular/forms';
import { FireType, FireCause, FireLocation } from '../fire';
import { Agency } from '../agency';
import { Site } from '../site';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BatsConfirmComponent } from '../lib/bats-confirm/bats-confirm.component';

@Component({
  selector: 'app-fire-log-form',
  templateUrl: './fire-log-form.component.html',
  styleUrls: ['./fire-log-form.component.scss']
})

export class FireLogFormComponent implements OnInit {
  @Input() public fire;
  @Input() public nofire;
  @Input() public sitecode;
  @Input() public reportNumbers;

  public editMode =  false;

  agencyList: Agency[];
  causeList: FireCause[];
  typeList: FireType[];
  locList: FireLocation[];
  sites: Site[];
  numberOfReports: number = 0;

  fireForm = this.fb.group({
    SITECODE: ['S900000001'],
    ID: [''],
    AGENCY_ID: [''],
    REPORT_NUMBER: [''],
    REPORT_DATE: [''],
    LOG_DATE: ['', Validators.required],
    TYPE_ID: ['', Validators.required],
    CAUSE_ID: [''],
    FIRE_PERIOD: [''],
    FIRE_DATE: [''],
    LOCATION: [''],
    BUILDING: [''],
    INJURY_COUNT: [''],
    DEATH_COUNT: [''],
    PROPERTY_DAMAGE: [''],
    COPY: [false],
  });

  constructor(public dialogRef: MatDialogRef<FireLogFormComponent>,
              private fireDataService: FireDataService,
              @Inject(MAT_DIALOG_DATA) public data: Site[],
              private fb: FormBuilder,
              private modalService: NgbModal) { }

  ngOnInit() {
    this.reportNumbers = this.data['reportNumbers'];
    this.sites = this.data['siteList'];
    this.loadAgencies();
    this.loadTypes();
    this.loadCauses();
    //this.loadLocations();

    if (this.fire !== undefined) {
      this.editMode = true;
      this.fireForm.get('SITECODE').setValue(this.fire.SITECODE);
      this.fireForm.get('ID').setValue(this.fire.ID);
      this.fireForm.get('AGENCY_ID').setValue(this.fire.AGENCY_ID);
      this.fireForm.get('REPORT_NUMBER').setValue(this.fire.REPORT_NUMBER);
      this.fireForm.get('REPORT_DATE').setValue(new Date(this.fire.REPORT_DATE_PRETTY));
      this.fireForm.get('LOG_DATE').setValue(new Date(this.fire.LOG_DATE + "T23:59:00"));
      this.fireForm.get('TYPE_ID').setValue(this.fire.TYPE_ID);
      this.fireForm.get('CAUSE_ID').setValue(this.fire.CAUSE_ID);
      this.fireForm.get('FIRE_PERIOD').setValue(new Date(this.fire.FIRE_DATE));
      this.fireForm.get('LOCATION').setValue(this.fire.LOCATION);
      this.fireForm.get('INJURY_COUNT').setValue(this.fire.INJURY_COUNT);
      this.fireForm.get('DEATH_COUNT').setValue(this.fire.DEATH_COUNT);
      this.fireForm.get('PROPERTY_DAMAGE').setValue(this.fire.PROPERTY_DAMAGE);
    }

    this.fireForm.controls.BUILDING.valueChanges.subscribe(e => (e?.BUILDING_NAME && this.fireForm.controls.LOCATION.setValue(e.BUILDING_NAME)))
    this.fireForm.controls.REPORT_NUMBER.valueChanges.subscribe(e=>{ this.numberOfReports  = this.reportNumbers.filter(x => e == x).length })
  }

  closeDialog() {
    this.dialogRef.close('closed');
  }// end closeDialog

  deleteFire() {
    const modalRef = this.modalService.open(BatsConfirmComponent)
    modalRef.result.then((result : any) => {
      this.fireDataService.deleteFire(this.fire.ID).subscribe(() => this.closeDialog());
    },
    (reason: any) => {
      return false;
    });
  }// end deleteFire




  copyFire(){
    this.editMode = false;
    this.fireForm.get('COPY').setValue(true);
    this.fireForm.get('REPORT_DATE').setValue(new Date(this.fireForm.value.REPORT_DATE));
    this.fireForm.get('LOG_DATE').setValue(new Date(this.fireForm.value.LOG_DATE));
    this.fireForm.get('FIRE_PERIOD').setValue(new Date(this.fireForm.value.FIRE_PERIOD));
  }

  loadAgencies() {
    this.fireDataService.getAgencies()
    .subscribe(agencyList => this.agencyList = agencyList);
  }// end loadAgencies

  loadCauses() {
    this.fireDataService.getCauses()
    .subscribe(causeList => this.causeList = causeList);
  }// end loadAgencies

  loadLocations() {
    this.fireDataService.getFireLocations(this.sitecode)
    .subscribe(locList => this.locList = locList);
  }// end loadDisposition

  loadTypes() {
    this.fireDataService.getTypes()
    .subscribe(typeList => this.typeList = typeList);
  }// end loadDisposition

  onSubmit() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    function setFireDates(dateObject, ie, trim){
      //var date = '';
      var dateString = '';
      if(ie){
        //date = dateObject.toLocaleString('en-US',{ hour12: false });
        var month = (dateObject.getMonth() < 9) ? '0'+ (dateObject.getMonth() + 1) :   dateObject.getMonth()+ 1;
        var day = (dateObject.getDate() < 10) ? '0'+ dateObject.getDate() : dateObject.getDate();
        var hours = (dateObject.getHours() < 10) ? '0'+ dateObject.getHours() : dateObject.getHours();
        var minutes = (dateObject.getMinutes() < 10) ? '0'+ dateObject.getMinutes() : dateObject.getMinutes();
        dateString = dateObject.getFullYear() + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

      }
      else{
        var date = dateObject.toLocaleString('en-US',{ hourCycle: 'h23' }) + " UTC";
        var dateNonUTC = new Date(date);
        dateString = dateNonUTC.toISOString();
      }

      dateString = dateString.substring(0,trim);

      return dateString;
    }


    this.fireForm.value.REPORT_DATE = (this.fireForm.value.REPORT_DATE) ? setFireDates(this.fireForm.value.REPORT_DATE, isIEOrEdge,16) : "";
    this.fireForm.value.FIRE_DATE = (this.fireForm.value.FIRE_PERIOD) ? setFireDates(this.fireForm.value.FIRE_PERIOD, isIEOrEdge,16) : "";
    this.fireForm.value.LOG_DATE = (this.fireForm.value.LOG_DATE) ? setFireDates(this.fireForm.value.LOG_DATE, isIEOrEdge,10) : "";

    if(this.fireForm.value.COPY){
      this.fireForm.value.ID = "";
    }

    // TODO: Use EventEmitter with form value
    if (this.editMode) {
      this.fireDataService.saveFire(this.fireForm.value)
      .subscribe(() => this.closeDialog());
    } else {
      this.fireDataService.addFire(this.fireForm.value)
      .subscribe(() => this.closeDialog());
    }
  }// end onSubmit

}
